import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ChevronRightBold = (props: IconProps) => {
  const { color } = props;
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 24 24">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6445 11.105L10.8316 6.05098C10.3623 5.55698 9.60078 5.55698 9.13053 6.05098C8.66027 6.54398 8.66027 7.34398 9.13053 7.83698L13.0919 11.998L9.13053 16.158C8.66027 16.652 8.66027 17.451 9.13053 17.945C9.36469 18.191 9.67335 18.315 9.98105 18.315C10.2888 18.315 10.5974 18.191 10.8316 17.945L15.6445 12.89C16.1157 12.398 16.1157 11.599 15.6445 11.105Z" fill="#C72037"/>
      </svg>
   </SvgIcon>
  );
}

export default ChevronRightBold;